<div [dropzone]="config" class="dropzone" (error)="onUploadError($event)" (success)="onUploadSuccess($event)"
  (queuecomplete)="onQueueComplete($event)">
  <div class="dz-default dz-message">
    <span>
      <span class="ico-upload"></span> Přetáhněte sem soubory, nebo klikněte pro výběr.
    </span>
  </div>
</div>
